module.exports = __webpack_public_path__ + "img/e5f380e.png";